<ng-scrollbar class="global-container" appearance="compact" #scrollable pointerEventsMethod="scrollbar">
  <div class="bread-crumb-container">
    <h2 class="margin-0">Reports</h2>
  </div>
  <div class="mt-3 mx-2">
    <form [formGroup]="reportForm" novalidate>
      <div class="adc-mb10">
        <mat-form-field appearance="outline" class="date date-range">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start date" #dateRangeStart>
            <input matEndDate placeholder="End date" #dateRangeEnd
              (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
          </mat-date-range-input>
          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <br>
      <div class="adc-mb10">
        <mat-form-field appearance="outline" class="report-ipt">
          <mat-label>Choose Facilitator</mat-label>
          <mat-select [formControl]="userServerSideCtrl" placeholder="Choose Facilitator">
            <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
            <mat-option>
              <ngx-mat-select-search [formControl]="userServerSideFilteringCtrl" [searching]="searching" placeholderLabel="Facilitator name" >
                <span ngxMatSelectNoEntriesFound>No entries found</span>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let user of filteredServerSideUsers | async" [value]="user">
              {{user.user_fullname}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <br>
      <p>
          <mat-form-field appearance="outline" class="report-ipt">
            <mat-label>Choose Meeting Status</mat-label>
            <!--<mat-select name="periodicElement" 
            [(value)]="selectedElement" placeholder="Choose Meeting Status">
              <mat-option [value]="">None</mat-option>  
              <mat-option [value]="'Com'">Completed</mat-option>
              <mat-option [value]="'NH'">Not Held</mat-option>
              <mat-option [value]="'A'">Approved</mat-option>
              <mat-option [value]="'YS'">Yet to Schedule</mat-option>
            </mat-select>-->
            <mat-select multiple placeholder="Choose Meeting Status">
              <mat-option (onSelectionChange)="change($event)" *ngFor="let status of meetingstatus" [value]="status.value">
                {{ status.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </p>
      <p>
        <button  type="button"  class="btn btn-outline-primary" (click)="download()">Download<img class="btn-icn" src="../../../assets/excel.png"/></button>
        &nbsp;&nbsp;
        <button type="button" class="btn btn-primary" (click)="getMeetingCount()">Get Count</button>
      </p>

    </form>
    <div *ngIf="isMeetingCnt">
      <span [ngStyle]="{'color':'#1565c0'}">The count is: {{meetingCnt}}</span>
    </div>
  
  </div>
</ng-scrollbar>
